"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractForm = void 0;
const react_1 = __importDefault(require("react"));
const ValidationErrors_1 = require("../../ValidationErrors");
class AbstractForm extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.getFormError = (fieldName) => {
            return (0, ValidationErrors_1.getFormError)(this.props.formErrors, fieldName);
        };
        this.handleFormDataChange = () => {
            this.props.onChange(this.state.formData);
        };
        this.handleFormInputChangeCheckBox = (event, fieldName) => {
            const { checked } = event.target;
            const formUpdate = {
                [fieldName]: checked,
            };
            this.handleFormInputChangeMassive(formUpdate);
        };
        this.handleFormInputChangeEvent = (event, fieldName) => {
            const { value } = event.target;
            const formUpdate = {
                [fieldName]: value,
            };
            this.handleFormInputChangeMassive(formUpdate);
        };
        this.handleFormInputChangeMassive = (formUpdate) => {
            const { formData } = this.state;
            this.setState({
                formData: {
                    ...formData,
                    ...formUpdate,
                },
            }, () => this.handleFormDataChange());
        };
    }
}
exports.AbstractForm = AbstractForm;
AbstractForm.defaultProps = {
    formData: {},
    formErrors: {},
};
//# sourceMappingURL=index.js.map